// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CardContainer_card-container__c8kpa {
  width: 100%;
  position: relative;
  background-color: var(--m-card-background-color);
  box-shadow: var(--m-header-box-shadow);
  border-radius: var(--m-border-radius-md);
}
.CardContainer_card-container__header__-1MXE {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  position: relative;
  z-index: 1;
  overflow: visible;
}
.CardContainer_card-container__header--title__5fkY2 {
  font-weight: 500;
  color: var(--m-text);
  font-size: 14px;
}
.CardContainer_card-container__header--action__Ghl08 {
  overflow: visible;
}
.CardContainer_card-container__header__-1MXE .CardContainer_filter-dropdown__0ziSP {
  border: 1px solid var(--m-border);
  border-radius: var(--m-border-radius);
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 3px 5px 3px 10px;
  cursor: pointer;
  font-size: 12px;
  color: var(--m-text);
}
.CardContainer_card-container__header__-1MXE .CardContainer_filter-dropdown__0ziSP svg {
  font-size: 18px;
}`, "",{"version":3,"sources":["webpack://./src/components/CustomUI/CardContainer/CardContainer.module.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,kBAAA;EACA,gDAAA;EACA,sCAAA;EACA,wCAAA;AACJ;AAEI;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;EACA,iBAAA;AAAR;AAGQ;EACI,gBAAA;EACA,oBAAA;EACA,eAAA;AADZ;AAIQ;EACI,iBAAA;AAFZ;AAKQ;EACI,iCAAA;EACA,qCAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,yBAAA;EACA,eAAA;EACA,eAAA;EACA,oBAAA;AAHZ;AAKY;EACI,eAAA;AAHhB","sourcesContent":[".card-container {\n    width: 100%;\n    position: relative;\n    background-color: var(--m-card-background-color);\n    box-shadow: var(--m-header-box-shadow);\n    border-radius: var(--m-border-radius-md);\n\n\n    &__header {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        padding: 16px;\n        position: relative;\n        z-index: 1;\n        overflow: visible;\n\n\n        &--title {\n            font-weight: 500;\n            color: var(--m-text);\n            font-size: 14px;\n        }\n\n        &--action {\n            overflow: visible;\n        }\n        \n        .filter-dropdown {\n            border: 1px solid var(--m-border);\n            border-radius: var(--m-border-radius);\n            display: flex;\n            align-items: center;\n            gap: 10px;\n            padding: 3px 5px 3px 10px;\n            cursor: pointer;\n            font-size: 12px;\n            color: var(--m-text);\n\n            svg {\n                font-size: 18px;\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card-container": `CardContainer_card-container__c8kpa`,
	"card-container__header": `CardContainer_card-container__header__-1MXE`,
	"card-container__header--title": `CardContainer_card-container__header--title__5fkY2`,
	"card-container__header--action": `CardContainer_card-container__header--action__Ghl08`,
	"filter-dropdown": `CardContainer_filter-dropdown__0ziSP`
};
export default ___CSS_LOADER_EXPORT___;
